import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltNotificationsPanelSettingsHeaderTitleWireframe from './VeltNotificationsPanelSettingsHeaderTitleWireframe/VeltNotificationsPanelSettingsHeaderTitleWireframe';
var VeltNotificationsPanelSettingsHeaderWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-settings-header-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelSettingsHeaderWireframe.Title = VeltNotificationsPanelSettingsHeaderTitleWireframe;
export default VeltNotificationsPanelSettingsHeaderWireframe;
